export default {
  'insert-resource-dialog.image.header': 'Insert image',
  'insert-resource-dialog.document.header': 'Insert document',
  'loader.please-wait': 'Please wait...',
  'insert-anchor-dialog.button-insert-anchor': 'Insert anchor',
  'insert-anchor-dialog.button-edit-anchor': 'Apply',
  'insert-anchor-dialog.button-cancel': 'Cancel',
  'insert-anchor-dialog.header.insert': 'Insert anchor',
  'insert-anchor-dialog.header.edit': 'Edit anchor',
  'insert-anchor.label': 'Anchor name',
  'insert-anchor.tip': 'E.g. "Second_Chapter" or "Top-header_1"',
  'insert-link-to-anchor-dialog.header.insert': 'Insert link to anchor',
  'insert-link-to-anchor-dialog.header.edit': 'Edit link to anchor',
  'insert-link-to-anchor-dialog.link-label': 'Link text',
  'insert-link-to-anchor-dialog.image-preview-label': 'Image preview',
  'insert-link-to-anchor-dialog.tooltip-label': 'Tooltip',
  'insert-link-to-anchor-dialog.button-insert-link': 'Insert link',
  'insert-link-to-anchor-dialog.button-edit-link': 'Apply',
  'insert-link-to-anchor-dialog.button-cancel': 'Cancel',
  'insert-link-to-anchor-dialog.button-unlink': 'Unlink',
  'insert-link-to-anchor-dialog.anchor-label': 'Anchor name',
  'insert-link-to-anchor-dialog.anchor-tooltip': 'E.g. "Second_Chapter" or "Top-header_1"',
  'insert-link-dialog.button-insert-link': 'Insert link',
  'insert-link-dialog.button-insert.slideshow': 'Insert',
  'insert-link-dialog.button-edit': 'Apply changes',
  'insert-link-dialog.button-cancel': 'Cancel',
  'insert-link-dialog.button-unlink': 'Unlink',
  'insert-link-dialog.header.insert': 'Insert link',
  'insert-link-dialog.header.edit': 'Edit link',
  'insert-link-dialog.header.slideshow': 'Slide Show Links',
  'insert-link-dialog.main-section-name': 'Enter link details',
  'insert-link-dialog.settings-section-name': 'Settings',
  'insert-link-dialog.settings.preview-image-alt': 'Link image preview',
  'insert-link-dialog.tab-switcher.website': 'Website/Email',
  'insert-link-dialog.tab-switcher.site-page': 'Site page',
  'insert-link-dialog.tab-switcher.event': 'Event',
  'insert-link-dialog.website-tab.url': 'Website URL or email',
  'insert-link-dialog.website-tab.url-hint': `Website address (URL) e.g. www.example.com
   OR email address e.g. john.doe@email.com`,
  'insert-link-dialog.site-page-tab.menu-pages': 'Menu pages',
  'insert-link-dialog.site-page-tab.not-in-menu-pages': 'Not in menu pages',
  'insert-link-dialog.site-page-tab.admin-only-page-warning': `Access to this page is
   currently restricted to administrators.`,
  'insert-link-dialog.site-page-tab.restricted-page-warning': `Access to this page is
   currently restricted to selected membership levels and/or member groups`,
  'insert-link-dialog.site-page-tab.load-error': 'Unable to load page data',
  'insert-link-dialog.events-tab.upcoming-events': 'Upcoming events',
  'insert-link-dialog.events-tab.past-events': 'Past events',
  'insert-link-dialog.events-tab.no-events-label': 'You have not created any events',
  'insert-link-dialog.events-tab.admin-only-event-warning': `Access to this event is currently
  restricted to administrators.`,
  'insert-link-dialog.events-tab.restricted-event-warning': `Access to this event is currently 
  restricted to selected membership levels and/or member groups.`,
  'insert-link-dialog.events-tab.load-error': 'Unable to load events',
  'insert-link-dialog.link-options.open-in.title': 'Open link in',
  'insert-link-dialog.link-options.open-in.new-window': 'New window',
  'insert-link-dialog.link-options.open-in.same-window': 'Same window',
  'insert-link-dialog.event-link-options.title': 'Link to',
  'insert-link-dialog.style-option.title': 'Style',
  'insert-link-dialog.event-link-options.details-page': 'Event details page',
  'insert-link-dialog.event-link-options.registrations-form': 'Registration form',
  'insert-link-dialog.link-label': 'Link text',
  'insert-link-dialog.image-preview-label': 'Image preview',
  'insert-link-dialog.tooltip-label': 'Tooltip',
  'insert-link-dialog.description-label': 'Description',
  'insert-macros-dialog.header': 'Macro (pre-defined information)',
  'insert-macros-dialog.button-save': 'Insert macro(s)',
  'insert-macros-dialog.button-cancel': 'Cancel',
  'insert-macros-dialog.fetch-error': 'Unable to load macros data',
  'insert-macros-dialog.header-sample-data': 'Sample data',
  'insert-image-dialog.error.directory-exists': 'Directory already exists',
  'insert-image-dialog.error.rename-directory': 'Rename directory failed',
  'insert-image-dialog.error.create-directory': 'Create directory failed',
  'insert-image-dialog.error.delete-directory': 'Delete directory failed',
  'insert-image-dialog.error.file-exists': 'File already exits',
  'insert-image-dialog.error.delete-file': 'Delete file failed',
  'insert-image-dialog.error.insufficient-space': 'Upload failed. Not enough space left.',
  'insert-image-dialog.error.bad-file-name':
    'File name contains one or more unsupported characters: \\\\ \\/ : * ? " < > | & # + %',
  'insert-image-dialog.error.bad-file-type': 'Unsupported file type',
  'insert-image-dialog.error.bad-file-size': 'File size exceeded',
  'insert-image-dialog.error.general': 'Error processing files'
};
